import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'
import router from '@/router'

import { bnForDbn } from '@/utils/data'

const shouldRouterUpdate = (to, from) => {
  // Check if we are updating route from BN to DBN to ignore second
  //  pageview since it has already been recorded under the BN
  const routesHaveSchools = (to.params.dbn || to.params.report_type ||
    from.params.dbn || from.params.report_type) !== undefined
  const isUpdatingBNToDBN = routesHaveSchools &&
    (to.params.report_type === from.params.report_type) &&
    (bnForDbn(to.params.dbn) === from.params.dbn)
  return !isUpdatingBNToDBN
}

export default function setup () {
  function getAnalyticsID () {
    var pathname = window.location.pathname
    if (pathname.indexOf('snapshot') > -1) {
      return process.env['SNAPSHOT_GA_ID']
    }
    console.log('There is no analytics ID registered for this path')
    return ''
  }

  function getGTagID () {
    var pathname = window.location.pathname
    if (pathname.indexOf('snapshot') > -1) {
      return process.env['SNAPSHOT_GTAG_ID']
    }
    console.log('There is no GTag ID registered for this path')
    return ''
  }

  Vue.use(VueAnalytics, {
    id: getAnalyticsID(),
    router,
    debug: {
      // Only allow debug comments in development, but this creates too many
      //   messages that clutter up console logs, so uncomment as needed just
      //   for testing
      // enabled: process.env.NODE_ENV === 'development',
      sendHitTask: true
    },
    autoTracking: {
      skipSamePath: false,
      pageviewTemplate (route) {
        return {
          page: route.path + window.location.hash,
          title: document.title,
          location: window.location.href
        }
      },
      shouldRouterUpdate
    }
  })

  Vue.use(VueGtag, {
    config: {id: getGTagID()}
    // If we include router argument, we would enable auto tracking but
    // we we don't want to do that because vue-gtag has no filtering method similar
    // to shouldRouterUpdate() as in vue-analytics. We have to filter them by ourself
  }/*, router */)

  router.afterEach((to, from) => {
    Vue.nextTick().then(() => {
      if (shouldRouterUpdate(to, from)) {
        // this is to match what we use(d) for vue-analytics
        const template = {
          page_title: document.title,
          page_path: to.path + window.location.hash,
          page_location: window.location.href
        }
        Vue.$gtag.pageview(template)
      }
    })
  })
}

export function logEvent (context, category, action, label) {
  context.$ga.event({
    eventCategory: category,
    eventAction: action,
    eventLabel: label
  })

  context.$gtag.event(
    action,
    {
      'event_category': category,
      'event_label': label
    }
  )
}



// WEBPACK FOOTER //
// ./src/helpers/google-analytics.js